import React from 'react'
import { Input } from "@chakra-ui/react"
import { Field } from "../../ui/field";
import { useColorModeValue } from '../../ui/color-mode';
import { darkMode, lightMode } from '../../../theme/config';

const InputBox = (props) => {
    const {label = '', invalid = false, errorText = '', register = {}, placeholder = '', disabled = false, size="md", type="", value, inputRef = null} = props;
    const backgroundColor = useColorModeValue(lightMode.boxBackgroundColor, darkMode.boxBackgroundColor);
    const textColor = useColorModeValue(lightMode.inputTextColor, darkMode.inputTextColor);
  return (
    <Field
        label={label}
        invalid={invalid}
        errorText={errorText}
    >
        <Input
            ref={inputRef}
            bg={backgroundColor}
            color={textColor}
            {...register}
            placeholder={placeholder}
            disabled={disabled}
            size={size}
            type={type}
            value={value !== undefined ? value : undefined}
            onFocus={(e) => {
                if (register && typeof register.onFocus === 'function') register.onFocus(e);
            }}
            onBlur={(e) => {
                if (register && typeof register.onBlur === 'function') register.onBlur(e);
            }}
        />
    </Field>
  )
}

export default InputBox
